__turbopack_context__.v({
  "banner": "Collateral-module-scss-module__43cOuq__banner",
  "content": "Collateral-module-scss-module__43cOuq__content",
  "cover": "Collateral-module-scss-module__43cOuq__cover",
  "cta": "Collateral-module-scss-module__43cOuq__cta",
  "meta": "Collateral-module-scss-module__43cOuq__meta",
  "stack": "Collateral-module-scss-module__43cOuq__stack",
  "title": "Collateral-module-scss-module__43cOuq__title",
});
